export function initLightbox() {
	const lightbox = document.getElementById('lightbox-global');
	if (!lightbox) return;

	const id = lightbox.dataset.id || 'default';
	const maxViews = parseInt(lightbox.dataset.maxViews || '1');

	const storageKey = `lightbox_${id}`;

	let data = {
		views: 0
	};

	// Obtener storage
	try {
		const stored = JSON.parse(localStorage.getItem(storageKey));
		if (stored && typeof stored === 'object') {
			data.views = stored.views || 0;
		}
	} catch (e) {}

	// 🚫 No mostrar si supera límite
	if (data.views >= maxViews) return;

	// Mostrar
	requestAnimationFrame(() => {
		lightbox.classList.add('_active');
	});

	// Incrementar vistas
	data.views += 1;
	localStorage.setItem(storageKey, JSON.stringify(data));

	// Cerrar con animación
	const close = () => {
		lightbox.classList.add('_out');

		setTimeout(() => {
			lightbox.classList.remove('_active');
			lightbox.classList.remove('_out');
		}, 500);
	};

	// Click delegation
	lightbox.addEventListener('click', (e) => {
		if (e.target.closest('[data-close="lightbox"]')) {
			close();
		}
	});

	// ESC
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			close();
		}
	});
}